var React = require('react');

function ArrowSmall (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"small arrow"),React.createElement("path",{"d":"M3.4,11.2C8.2,9.8,11.7,5.3,11.7,0h-0.5c0,6.2-5,11.2-11.2,11.2v0.5c6.2,0,11.2,5,11.2,11.2h0.5c0-5.3-3.5-9.8-8.4-11.2\n\tL3.4,11.2z","key":1})]);
}

ArrowSmall.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 41.4 23","style":{"enableBackground":"new 0 0 41.4 23"},"xmlSpace":"preserve"};

module.exports = ArrowSmall;

ArrowSmall.default = ArrowSmall;
